module.exports = __webpack_public_path__ + "img/ardi-logo.fbd02528.png";